import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// null 是 checkbox
// string 是有具体值的
export type CommentEligibilityType = Record<string, any>;

export const commentEligibilityState = atomWithStorage<CommentEligibilityType>(
  'CE_comment_eligibility',
  { has_web3_id: null },
);

// 只用来保存本地偏好，不与其它端同步
export const useCommentEligibility = () => {
  return useAtom(commentEligibilityState);
};
